export const MENU_CONTENT_MAX_WIDTH_PX = 560
